import { render, staticRenderFns } from "./AttendanceFixTemporaryDialog.vue?vue&type=template&id=45afa7c8"
import script from "./AttendanceFixTemporaryDialog.vue?vue&type=script&lang=js"
export * from "./AttendanceFixTemporaryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports